<template>
  <div
    class="kv-ve__block"
    :class="{ selected: isSelected }"
    @click.stop="$emit('select')"
  >
    <div v-if="isSelected" class="kv-ve__block-tools">
      <span class="kv-ve__drag-handle" :title="t('visual_editor-drag_block')">⋮⋮</span>
      <button type="button" class="kv-ve__tool" :title="t('visual_editor-duplicate')" @click.stop="$emit('duplicate')">
        ⧉
      </button>
      <button type="button" class="kv-ve__tool danger" :title="t('visual_editor-delete')" @click.stop="$emit('delete')">
        🗑
      </button>
    </div>

    <component :is="componentName" :block="block" :selected="isSelected" />
  </div>
</template>

<script>
export default {
  name: "VeBlockHost",
  props: {
    block: { type: Object, required: true },
    componentName: { type: String, required: true },
    isSelected: { type: Boolean, default: false },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>


